import React, { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import { Select, Checkbox, message, Switch, Popconfirm } from "antd"
import { createPriorityStore } from "../../../../services/api/apiReGenerateLabel"

const EditShippingCarrier = ({ modal, handleCloseModalEdit, slugForm, shippingCarrierForm, originalCarrierForm, trackingURLForm, shippingBoxForm, originalCarrierStatusForm, labelGenerationStatusForm, handleChangeInput, handleChangeOriginalCarrierStatus, handleChangeLabelGenerationStatus, handleSaveChange, shippingCarrier, error}) => {

    const _handleCloseModal = () => {
        handleCloseModalEdit()
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        handleChangeInput(name, value)
    }

    const _handleChangeOriginalCarrierStatus = (checked) => {
        handleChangeOriginalCarrierStatus(!checked)
    }

    const _handleChangeLabelGenerationStatus = (checked) => {
        handleChangeLabelGenerationStatus(!checked)
    }

    const _handleSaveChange = () => {
        handleSaveChange()
    }

    const _renderTitleConfirm = (field, status) => {
        return (
            <div>
                If you turn {status ? 'OFF' : 'ON'} the { field === 'originalCarrierStatus' ? 'original carrier status' : 'label generation status'}, { field === 'originalCarrierStatus' ? status ? 'the shipping rules of this carrier cannot be detected' : ' the shipping rules of this carrier will be detected again' : status ? 'the labels of this original carrier can not be generated' : 'the labels of this original carrier will be generated again'}.<span style={{display: 'block'}}>Do you want to turn it {status ? 'OFF' : 'ON'}?</span>
            </div>
        )
    }

    const isDisable = shippingCarrier.name === shippingCarrierForm && shippingCarrier.original_carrier === originalCarrierForm && shippingCarrier.box_name === shippingBoxForm && shippingCarrier.tracking_url === trackingURLForm && shippingCarrier.is_active === originalCarrierStatusForm && shippingCarrier.is_generation_label_enabled === labelGenerationStatusForm ? true : false

    return (
        <Modal isOpen={modal} toggle={_handleCloseModal}>
            <ModalHeader toggle={_handleCloseModal}>Edit shipping carrier</ModalHeader>
            <ModalBody>
            <div className="NameStore mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Slug</label>
                    <div className="col-sm-9">
                        <input
                            name="slug"
                            className="ant-input"
                            onChange={_handleChangeInput}
                            value={slugForm || ''}
                            disabled={true}
                            style={{fontWeight: "bold", color: "rgba(0,0,0,1)"}}
                        />
                    </div>
                </div>
                <div className="NameStore mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Shipping carrier</label>
                    <div className="col-sm-9">
                        <input
                            name="shippingCarrier"
                            className="ant-input"
                            onChange={_handleChangeInput}
                            value={shippingCarrierForm || ''}
                            style={{fontWeight: "bold"}}
                        />
                    </div>
                </div>
                <div className="NameStore mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Original carrier</label>
                    <div className="col-sm-9">
                        <input
                            name="originalCarrier"
                            className="ant-input"
                            onChange={_handleChangeInput}
                            value={originalCarrierForm || ''}
                            style={{fontWeight: "bold"}}
                        />
                        {/* {!!error.originalCarrier && (
                            <div className="text-danger mt-1">{error.originalCarrier}</div>
                        )} */}
                        {/* {!!error.namespace && (
                            <div className="text-danger mt-1">{error.namespace}</div>
                        )} */}
                    </div>
                </div>
                {/* <div className="NameStore mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Tracking URL</label>
                    <div className="col-sm-9">
                        <input
                            name="trackingURL"
                            className="ant-input"
                            onChange={_handleChangeInput}
                            value={trackingURLForm || ''}
                            style={{fontWeight: "bold"}}
                        />
                    </div>
                </div> */}
                <div className="NameStore mb-3 row">
                    <label className="col-sm-3 col-form-label font-weight-bold">Shipping box</label>
                    <div className="col-sm-9">
                        <input
                            name="box_name"
                            className="ant-input"
                            onChange={_handleChangeInput}
                            value={shippingBoxForm || ''}
                            style={{fontWeight: "bold"}}
                        />
                    </div>
                </div>
                <div className="ProductType mb-3 row">
                    <label className="col-sm-3 font-weight-bold">Original carrier status</label>
                    <div className="col-sm-9">
                        <Popconfirm
                            title={_renderTitleConfirm('originalCarrierStatus', originalCarrierStatusForm)}
                            onConfirm={() => _handleChangeOriginalCarrierStatus(originalCarrierStatusForm)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Switch checked={originalCarrierStatusForm}/>
                        </Popconfirm>
                    </div>
                </div>
                <div className="ProductType mb-3 row">
                    <label className="col-sm-3 font-weight-bold">Label generation status</label>
                    <div className="col-sm-9">
                        <Popconfirm
                            title={_renderTitleConfirm('labelGenerationStatus', labelGenerationStatusForm)}
                            onConfirm={() => _handleChangeLabelGenerationStatus(labelGenerationStatusForm)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Switch checked={labelGenerationStatusForm}/>
                        </Popconfirm>
                    </div>
                </div>

                {!!error && (
                    <div className="text-danger mt-1">{error}</div>
                )}
            </ModalBody>
            <ModalFooter>
                <button className="btn btn-secondary mr-auto" onClick={_handleCloseModal}>
                    Cancel
                </button>
                <button className="btn btn-primary" onClick={_handleSaveChange} disabled={isDisable}>
                    Save
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default EditShippingCarrier